// src/theme/components/container.js
// Container component için mobil optimize padding
// Faz 5 · Semantic container size alias'lari eklendi.
//   narrow  → dar metin bloklari (ayar formlari, modal icerigi)
//   reading → okuma (lecture/algospot) · 720px optimal satir uzunlugu
//   page    → varsayilan icerik konteynerleri (1024px)
//   wide    → hub / store / dashboard (1280px)
//   full    → tam genislik (limit yok)

const Container = {
  baseStyle: {
    w: '100%',
    mx: 'auto',
    maxW: '100%',
    // Mobil için daha kompakt padding
    px: { base: 3, sm: 4, md: 6, lg: 8 },  // 12px, 16px, 24px, 32px
  },
  sizes: {
    sm: {
      maxW: '640px',
      px: { base: 3, sm: 4 },
    },
    md: {
      maxW: '768px',
      px: { base: 3, sm: 4, md: 6 },
    },
    lg: {
      maxW: '1024px',
      px: { base: 3, sm: 4, md: 6, lg: 8 },
    },
    xl: {
      maxW: '1280px',
      px: { base: 3, sm: 4, md: 6, lg: 8 },
    },
    '2xl': {
      maxW: '1536px',
      px: { base: 3, sm: 4, md: 6, lg: 8 },
    },
    // Semantic alias'lar · her sayfa bunlari kullansin, sert genislik yazmasin.
    narrow: {
      maxW: '560px',
      px: { base: 3, sm: 4 },
    },
    reading: {
      maxW: '720px',
      px: { base: 3, sm: 4, md: 6 },
    },
    page: {
      maxW: '1024px',
      px: { base: 3, sm: 4, md: 6, lg: 8 },
    },
    wide: {
      maxW: '1280px',
      px: { base: 3, sm: 4, md: 6, lg: 8 },
    },
    full: {
      maxW: '100%',
      px: { base: 3, sm: 4, md: 6, lg: 8 },
    },
  },
};

export default Container;
